// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"ZY-z","subtitle":"_Y-z","wrapper":"aZ-z","leftArrow":"bZ-z","rightArrow":"cZ-z"};